import { render, staticRenderFns } from "./MediaNoBody.vue?vue&type=template&id=5fecf97f&"
import script from "./MediaNoBody.vue?vue&type=script&lang=js&"
export * from "./MediaNoBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports